/*
 * Copyright ©2020. Open Digital Solutions, Novi Sad. Sva prava zadržana.
 * Pravo da se koristi, kopira, modifikuje i distribuira ovaj softver i njegova dokumentacija
 * u bilo koje svrhe, bez naknade ili bez potpisanog sporazuma sa vlasnikom softvera, nije dozvoljeno.
 */

import { Component, ViewChild, ElementRef, ViewEncapsulation, Optional, Inject, ChangeDetectorRef, NgZone } from '@angular/core';
import { SubjectsService } from './../../../services/subjects.service';
import { Page } from '../../page';
import { CustomPaginationService } from 'src/services/custom-pagination.service';
import { Subject } from 'src/models/subject.model';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { SubjectFormComponent } from 'src/app/subjects/subject-form/subject-form.component';
import { environment } from 'src/environments/environment';
import { CodebookService } from 'src/services/codebook.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LocalStorageService } from 'src/app/local-storage.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { UserService } from 'src/services/user.service';
import { CpsuSubjectService } from 'src/services/cpsu-subject.service';
import { ToastrImplService } from 'src/services/toastr.service';
import { ServiceProviderSubjectService } from 'src/services/service-provider-subject.service';

export interface SearchItem {
   name: string;
}

enum AutocompleteFilterEnum {
   SUBCENTER = 'subcenter',
}

interface SelectOptions {
   value: any;
   viewValue: string;
}

@Component({
   selector: 'side-subjects',
   templateUrl: './side-subjects.component.html',
   styleUrls: ['./side-subjects.component.scss'],
   encapsulation: ViewEncapsulation.None,
})
export class SideSubjectsComponent {
   selectable = true;
   removable = true;
   readonly separatorKeysCodes: number[] = [COMMA, ENTER];
   public searchTerms: string[] = [];

   public globalFilter = '';
   public searchItems: SearchItem[] = [];
   page: Page<Subject> = new Page();
   public resetCourses = this.page;
   myInput = '';
   object: { origin: string };
   newSubject: any;

   displayedColumns: string[] = ['registrationId', 'id', 'lastName', 'firstName', 'dateOfBirth', 'jmbg'];
   displayedColumnsCpsu: string[] = ['csrName', 'registrationId', 'lastName', 'firstName', 'dateOfBirth', 'jmbg'];
   displayedColumnsServiceProviders: string[] = ['fromCsrName', 'registrationId', 'lastName', 'firstName', 'dateOfBirth', 'jmbg'];
   areLoaded = false;
   fileUrl: any;
   subcenter = new FormControl();
   subcenterCsrId: any;
   subcenters = [];
   loggedIn: any;
   isMainBelgradeCenter = false;
   isUserDrugostepeni = false;
   isGlobalAdmin = false;
   isCpsuUser = false;
   isServiceProviderUser = false;
   filteredSubcenters: Observable<any>;
   isCpsuCenter = false;
   @ViewChild('pdfTable', { static: false }) pdfTable: ElementRef;
   filterForm: FormGroup;
   filterInUse = false;
   statusOptions: SelectOptions[] = [
      { value: 'ALL', viewValue: 'СВИ СТАТУСИ' },
      { value: 'ACTIVE', viewValue: 'АКТИВАН' },
      { value: 'PASSIVE', viewValue: 'ПАСИВАН' },
      { value: 'UNDEFINED', viewValue: 'НЕДЕФИНИСАН' },
   ];
   constructor(
      private subjectsService: SubjectsService,
      public dialog: MatDialog,
      @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
      @Optional() public dialogRef: MatDialogRef<SubjectFormComponent>,
      private paginationService: CustomPaginationService,
      private cdr: ChangeDetectorRef,
      public router: Router,
      private codebookService: CodebookService,
      private localStorageService: LocalStorageService,
      private userService: UserService,
      private cpsuSubjectService: CpsuSubjectService,
      private formBuilder: FormBuilder,
      private toastr: ToastrImplService,
      private serviceProviderSubjectService: ServiceProviderSubjectService
   ) {
      this.filterForm = this.formBuilder.group({
         status: ['ALL'],
         address: [''],
      });
      this.loggedIn = JSON.parse(this.localStorageService.get('loggedUser'));
      this.isCpsuUser = this.loggedIn.isCpsu;
      this.isServiceProviderUser = this.loggedIn.isServiceProviderUser;
      this.isUserDrugostepeni = this.userService.isUserDrugostepeni();
      this.isGlobalAdmin = this.userService.isGlobalAdmin();
      this.isMainBelgradeCenter = this.userService.isUserMainBelgrade();

      if (this.isUserDrugostepeni || this.isMainBelgradeCenter || this.isGlobalAdmin) {
         this.subcenterCsrId = 0;
      }

      if (this.isUserDrugostepeni || this.isGlobalAdmin) {
         // Drugostepeni - svi centri
         this.codebookService.getCsrCodebook().subscribe(result => {
            this.subcenters = result;
            this.filteredSubcenters = this.subcenter.valueChanges.pipe(
               startWith(''),
               map(value => (typeof value === 'string' ? value : value.name)),
               map(title => (title ? this._filter(title, AutocompleteFilterEnum.SUBCENTER) : this.subcenters.slice()))
            );
         });
      } else if (this.isMainBelgradeCenter) {
         // Glavni centar Beograd - podcentri
         this.codebookService.getAllSubcenters().subscribe(result => {
            this.subcenters = result;
            this.filteredSubcenters = this.subcenter.valueChanges.pipe(
               startWith(''),
               map(value => (typeof value === 'string' ? value : value.name)),
               map(title => (title ? this._filter(title, AutocompleteFilterEnum.SUBCENTER) : this.subcenters.slice()))
            );
         });
      }

      this.object = { ...data };
      this.doFilter();
   }

   public getNextPage(): void {
      this.areLoaded = false;
      this.page.pageable = this.paginationService.getNextPage(this.page);
      this.doFilter();
   }

   public getPreviousPage(): void {
      this.areLoaded = false;
      this.page.pageable = this.paginationService.getPreviousPage(this.page);
      this.doFilter();
   }

   public getFirstPage(): void {
      this.areLoaded = false;
      this.page.pageable = this.paginationService.getFirstPage(this.page);
      this.doFilter();
   }

   public getLastPage(): void {
      this.areLoaded = false;
      this.page.pageable = this.paginationService.getLastPage(this.page);
      this.doFilter();
   }

   public getPageInNewSize(pageSize: any): void {
      this.areLoaded = false;
      this.page.pageable = this.paginationService.getPageInNewSize(this.page, pageSize);
      this.doFilter();
   }

   doFilter() {
      if (!((this.isMainBelgradeCenter || this.isUserDrugostepeni || this.isGlobalAdmin) && this.subcenterCsrId === undefined)) {
         const body = {
            pageId: this.page.pageable.pageNumber,
            sizeId: this.page.pageable.pageSize,
            csrId: this.isMainBelgradeCenter || this.isUserDrugostepeni || this.isGlobalAdmin ? this.subcenterCsrId : this.loggedIn?.csrId,
            searchData: this.searchTerms,
            status: this.filterInUse ? this.filterForm.value.status : null,
            address: this.filterInUse && this.filterForm.value.address != '' ? this.filterForm.value.address : null,
         };
         if (this.isCpsuUser || this.isCpsuCenter) {
            this.cpsuSubjectService.getFilteredPage(body).subscribe(page => {
               this.page = page;
               this.page.pageable.pagePerShow = page.number + 1;
               for (const element of this.page.content) {
                  if (element.dateOfBirth !== null) {
                     element.dateOfBirth = (element.dateOfBirth as any).replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3');
                  }
               }
               this.areLoaded = true;
               this.cdr.detectChanges();
            });
         }  else if (this.isServiceProviderUser) {
            const serviceProviderBody = {
               pageId: this.page.pageable.pageNumber,
               sizeId: this.page.pageable.pageSize,
               serviceProviderId: this.loggedIn?.serviceProviderId,
               searchData: this.searchTerms,
            }
            this.serviceProviderSubjectService.getFilteredPage(serviceProviderBody).subscribe(page => {
               this.page = page;
               this.page.pageable.pagePerShow = page.number + 1;
               for (const element of this.page.content) {
                  if (element.dateOfBirth !== null) {
                     element.dateOfBirth = (element.dateOfBirth as any).replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3');
                  }
               }
               this.areLoaded = true;
               this.cdr.detectChanges();
            });
         } else {
            this.subjectsService.getFilteredPage(body).subscribe(page => {
               this.page = page;
               this.page.pageable.pagePerShow = page.number + 1;
               for (const element of this.page.content) {
                  if (element.dateOfBirth !== null) {
                     element.dateOfBirth = (element.dateOfBirth as any).replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3');
                  }
                  element.dateOfCreation = (element.dateOfCreation as any).replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3');
               }
               this.areLoaded = true;
               this.cdr.detectChanges();
            });
         }
      } else {
         this.toastr.info('SUBJECTS.WARMING_CENTAR');
      }
   }

   add(event: MatChipInputEvent): void {
      const input = event.input;
      const value = event.value;
      // Add new search term
      if ((value || '').trim()) {
         this.searchItems.push({ name: value.trim() });
      }
      // Reset the input value
      if (input) {
         input.value = '';
      }
      this.searchTerms = this.searchItems.map(function (searchItem) {
         return searchItem.name;
      });
      this.globalFilter = '';
      this.applyFilter(this.searchTerms);
   }

   remove(item: SearchItem): void {
      const index = this.searchItems.indexOf(item);
      if (index >= 0) {
         this.searchItems.splice(index, 1);
         this.searchTerms = this.searchItems.map(function (searchItem) {
            return searchItem.name;
         });
         this.applyFilter(this.searchTerms);
      }
   }

   applyFilter(filterValue: any) {
      this.globalFilter = filterValue;
      this.page.pageable.pageNumber = 0;
      this.doFilter();
   }

   // Otvaranje stranice za kreiranje novog koriniska u novom tabu
   newSubjectInNewTab() {
      window.open(environment.getNewSubjectTab, '_blank');
   }

   reloadSubjects(event: any) {
      this.areLoaded = false;
      this.subcenterCsrId = event?.id;
      this.isCpsuCenter = event.isCpsu;

      this.doFilter();
   }

   private _filter(value: string, what: AutocompleteFilterEnum): any[] {
      const filterValue = value.toLowerCase();

      switch (what) {
         case AutocompleteFilterEnum.SUBCENTER:
            return this.subcenters.filter(option => option.name.toLowerCase().includes(filterValue));
         default:
            break;
      }
   }

   displayCustomFormat(objectValue: any): string {
      return objectValue ? objectValue.name : objectValue;
   }
   clickSubject(subjectId: any) {
      if (this.isCpsuUser) {
         window.open(environment.getCpsuSubjectDetails + subjectId, '_blank');
      } else if (this.isServiceProviderUser) {
         window.open(environment.getServiceProviderSubjectDetails + subjectId, '_blank');
      } else {
         this.localStorageService.set('localStorageCenterId', this.isMainBelgradeCenter || this.isUserDrugostepeni || this.isGlobalAdmin ? this.subcenterCsrId : this.loggedIn?.csrId);
         window.open(environment.getFamilyMemberTab + subjectId, '_blank');
      }
   }

   resetFilter() {
      this.filterInUse = false;
      this.filterForm.controls.status.setValue('ALL');
      this.filterForm.controls.address.setValue('');
      this.page.pageable.pageNumber = 0;
      this.doFilter();
   }

   compareLoadedObjects(object1: any, object2: any) {
      return object1 && object2 && object1 === object2;
   }
   applyCustomFilter() {
      this.filterInUse = true;
      this.page.pageable.pageNumber = 0;
      this.doFilter();
   }
}
